import React from 'react';

import {createRoot} from 'react-dom/client';
import 'reflect-metadata';

import {App} from './app.component';
import {initSentry} from './modules/sentry';

initSentry();

const ROOT = document.getElementById('root');

if (ROOT) {
    createRoot(ROOT).render(<App/>);
}
